import React from "react";
import { graphql } from "gatsby";
import get from 'lodash.get';
import LaunchDetails from "../components/launchDetails";
import Layout from "../components/layout";
import ProductsList from "../components/productsList";

const retailers = [
  {
    key: 'amazon',
    name: 'Amazon'
  }/*, {
    key: 'newegg',
    name: 'Newegg'
  }, {
    key: 'adorama',
    name: 'Adorama'
  }, {
    key: 'bestbuy',
    name: 'Best Buy'
  }, {
    key: 'bhphoto',
    name: 'B&H Photo'
  }, {
    key: 'asusstore',
    name: 'Asus Store'
  }, {
    key: 'pnystore',
    name: 'PNY Store'
  }, {
    key: 'zotac',
    name: 'Zotac'
  }, {
    key: 'amdstore',
    name: 'AMD Store'
  }, {
    key: 'gamestop',
    name: 'GameStop'
  }, {
    key: 'target',
    name: 'Target'
  }, {
    key: 'walmart',
    name: 'Walmart'
  }, {
    key: 'microsoftstore',
    name: 'Microsoft Store'
  }, {
    key: 'meijer',
    name: 'Meijer'
  }, {
    key: 'pcrichardandson',
    name: 'PC Richard & Son'
  }, {
    key: 'playstationstore',
    name: 'PlayStation Store'
  }*/
];

const ListRetailer = ({ retailer, props }) => {
  const products = get(props, `data.${retailer.key}.nodes`);
  if (!products || products.length < 1) return null;
  const totalCount = get(props, `data.${retailer.key}.totalCount`);

  return (
    <div>
      <div className="products-header">
        <h2>{retailer.name}</h2>
        {(totalCount > 0) && 
          <div className="retailer-product-count">Total: {totalCount}</div>
        }
      </div>
      <ProductsList products={products} key={retailer.key} />
    </div>
  )
}

const list = ( props ) => {
  const relatedPages = get(props, 'pageContext.relatedPages', []);
  const name = get(props, 'pageContext.name', '');
  const launch = get(props, 'pageContext.launch');
  const totalCount = get(props, `data.all.totalCount`);

  return (
    <Layout relatedPages={relatedPages} name={name} showBurger={true} blog={true}>
      <div className="products full-page-module">
        <div className="products-header">
          <h1>{name}</h1>
          {(totalCount > 0) &&
            <div className="retailer-product-count">Total: {totalCount}</div>
          }
        </div>
        {launch && <LaunchDetails launch={launch} />}
        {retailers.map(retailer =>
          <ListRetailer
            retailer={retailer}
            props={props}
            key={retailer.key}
          />
        )}
      </div>
    </Layout>
  )
}

export const pageQuery = graphql`
  query($tag: [String]) {
    amazon: allMongodbDevelopProducts(filter: {tags: {in: $tag}, retailer: {eq: "Amazon"}}, sort: {fields: name}) {
      totalCount
      nodes {
        mongodb_id
        name
        scrapeUrl
        affiliateUrl
        retailer
        tags
      }
    }
  }
`

export default list;
